import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Star } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-dream-light-beige via-dream-soft-beige to-dream-pink-beige text-gray-800 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-10 left-10 w-32 h-32 bg-gradient-to-r from-dream-teal to-dream-warm-brown rounded-full blur-3xl opacity-15"></div>
        <div className="absolute bottom-10 right-10 w-24 h-24 bg-gradient-to-r from-dream-pink-beige to-dream-soft-beige rounded-full blur-2xl opacity-15"></div>
      </div>

      <div className="container-width px-6 py-12 relative z-10">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h3 className="text-2xl font-bold mb-4 gradient-text">לחלום בגדול</h3>
                         <p className="text-gray-600 leading-relaxed mb-4">
               סדנת לוח חזון באוזניות ייחודית שמעבירה אותכם למסע קסום 
               לעבר העתיד המיטבי שלכם.
             </p>
             <div className="flex gap-2">
               <motion.div
                 animate={{ y: [-2, 2, -2] }}
                 transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
               >
                 <Star size={16} className="text-dream-teal" />
               </motion.div>
               <span className="text-gray-600 text-sm">חוויה ייחודית בארץ</span>
             </div>
          </motion.div>
        </div>

        {/* Bottom Section */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          viewport={{ once: true }}
          className="border-t border-dream-warm-brown pt-8"
        >
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-gray-600 text-sm">
              © {currentYear} לחלום בגדול. כל הזכויות שמורות.
            </div>
            <div className="flex items-center gap-2 text-gray-600 text-sm">
              <span>נבנה ב</span>
              <motion.div
                animate={{ scale: [1, 1.2, 1] }}
                transition={{ duration: 2, repeat: Infinity }}
              >
                <Heart size={14} className="text-dream-pink-beige fill-current" />
              </motion.div>
              <span>על ידי</span>
              <a 
                href="https://mapu.co.il" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-dream-warm-brown hover:text-dream-teal transition-colors underline"
              >
                מאפו בניית אתרים
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
